var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetricUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8022_9836)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8022_9836",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8022_9836)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0H4C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H20C22.2091 24 24 22.2091 24 20V4C24 1.79086 22.2091 0 20 0Z",
    fill: "url(#paint0_linear_8022_9836)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4566 9.35625C15.4129 9.35 15.3691 9.35 15.3254 9.35625C14.3566 9.325 13.5879 8.53125 13.5879 7.55625C13.5879 6.5625 14.3941 5.75 15.3941 5.75C16.3879 5.75 17.2004 6.55625 17.2004 7.55625C17.1941 8.53125 16.4254 9.325 15.4566 9.35625Z",
    fill: "#F4FFFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4938 13.6875C16.7938 14.1563 15.8125 14.3313 14.9062 14.2125C15.1437 13.7 15.2687 13.1313 15.275 12.5313C15.275 11.9063 15.1375 11.3125 14.875 10.7938C15.8 10.6688 16.7813 10.8438 17.4875 11.3125C18.475 11.9625 18.475 13.0313 17.4938 13.6875Z",
    fill: "#F4FFFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.52461 9.35625C8.56836 9.35 8.61211 9.35 8.65586 9.35625C9.62461 9.325 10.3934 8.53125 10.3934 7.55625C10.3934 6.55625 9.58711 5.75 8.58711 5.75C7.59336 5.75 6.78711 6.55625 6.78711 7.55625C6.78711 8.53125 7.55586 9.325 8.52461 9.35625Z",
    fill: "#F4FFFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.59395 12.5311C8.59395 13.1374 8.7252 13.7124 8.9627 14.2311C8.08145 14.3249 7.1627 14.1374 6.4877 13.6936C5.5002 13.0374 5.5002 11.9686 6.4877 11.3124C7.15645 10.8624 8.1002 10.6811 8.9877 10.7811C8.73145 11.3061 8.59395 11.8999 8.59395 12.5311Z",
    fill: "#F4FFFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.075 14.4187C12.025 14.4125 11.9687 14.4125 11.9125 14.4187C10.7625 14.3812 9.84375 13.4375 9.84375 12.275C9.85 11.0875 10.8062 10.125 12 10.125C13.1875 10.125 14.15 11.0875 14.15 12.275C14.1437 13.4375 13.2312 14.3812 12.075 14.4187Z",
    fill: "#F4FFFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0437 15.7124C9.10001 16.3437 9.10001 17.3812 10.0437 18.0062C11.1187 18.7249 12.8812 18.7249 13.9562 18.0062C14.9 17.3749 14.9 16.3374 13.9562 15.7124C12.8875 14.9937 11.125 14.9937 10.0437 15.7124Z",
    fill: "#F4FFFC"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8022_9836",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8022_9836"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetricUsers);
export default __webpack_public_path__ + "static/media/Metric-Users.fdffceb2872bbbed8e7065bfca1a6cc4.svg";
export { ForwardRef as ReactComponent };